export default __webpack_public_path__ + "static/media/220.75ea3ee3.jpg";